import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App.jsx';
import './index.css';

// Clerk auth (for lumosity_infra API calls) is opt-in: without a publishable
// key the app runs exactly as before and all Lumosity features stay hidden.
const CLERK_PK = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const app = CLERK_PK ? (
  <ClerkProvider publishableKey={CLERK_PK}>
    <App />
  </ClerkProvider>
) : (
  <App />
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>{app}</React.StrictMode>
);
